// Create Project page translations
export const createProjectTranslations = {
  en: {
    "title": "Create New Project",
    "fields": {
      "name": "Project Name",
      "outline": "Interview Outline",
      "recordAudio": "Record Audio",
      "interviewType": "Interview Type",
      "interviewLanguage": "Interview Language",
      "maxDuration": "Maximum Interview Duration"
    },
    "actions": {
      "create": "Create Project"
    },
    "errors": {
      "createFailed": "Failed to create project"
    }
  },
  zh: {
    "title": "创建新项目",
    "fields": {
      "name": "项目名称",
      "outline": "访谈大纲",
      "recordAudio": "录制音频",
      "interviewType": "访谈类型",
      "interviewLanguage": "访谈语言",
      "maxDuration": "最大访谈时长"
    },
    "actions": {
      "create": "创建项目"
    },
    "errors": {
      "createFailed": "创建项目失败"
    }
  },
  fr: {
    "title": "Créer un nouveau projet",
    "fields": {
      "name": "Nom du projet",
      "outline": "Plan d'entretien",
      "recordAudio": "Enregistrer l'audio",
      "interviewType": "Type d'entretien",
      "interviewLanguage": "Langue de l'entretien",
      "maxDuration": "Durée maximale de l'entretien"
    },
    "actions": {
      "create": "Créer le projet"
    },
    "errors": {
      "createFailed": "Échec de la création du projet"
    }
  },
  nb: {
    "title": "Opprett nytt prosjekt",
    "fields": {
      "name": "Prosjektnavn",
      "outline": "Intervjudisposisjon",
      "recordAudio": "Ta opp lyd",
      "interviewType": "Intervjutype",
      "interviewLanguage": "Intervjuspråk",
      "maxDuration": "Maksimal intervjuvarighet"
    },
    "actions": {
      "create": "Opprett prosjekt"
    },
    "errors": {
      "createFailed": "Kunne ikke opprette prosjekt"
    }
  },
  nl: {
    "title": "Nieuw Project Maken",
    "fields": {
      "name": "Projectnaam",
      "outline": "Interviewschema",
      "recordAudio": "Audio Opnemen",
      "interviewType": "Interviewtype",
      "interviewLanguage": "Interviewtaal",
      "maxDuration": "Maximale Interviewduur"
    },
    "actions": {
      "create": "Project Maken"
    },
    "errors": {
      "createFailed": "Project maken mislukt"
    }
  },
  de: {
    "title": "Neues Projekt Erstellen",
    "fields": { "name": "Projektname", "outline": "Interviewleitfaden", "recordAudio": "Audio Aufnehmen", "interviewType": "Interviewtyp", "interviewLanguage": "Interviewsprache", "maxDuration": "Maximale Interviewdauer" },
    "actions": { "create": "Projekt Erstellen" },
    "errors": { "createFailed": "Projekt erstellen fehlgeschlagen" }
  },
  es: {
    "title": "Crear Nuevo Proyecto",
    "fields": { "name": "Nombre del proyecto", "outline": "Guión de entrevista", "recordAudio": "Grabar audio", "interviewType": "Tipo de entrevista", "interviewLanguage": "Idioma de la entrevista", "maxDuration": "Duración máxima de la entrevista" },
    "actions": { "create": "Crear Proyecto" },
    "errors": { "createFailed": "Error al crear el proyecto" }
  },
  pt: {
    "title": "Criar Novo Projeto",
    "fields": { "name": "Nome do Projeto", "outline": "Roteiro de Entrevista", "recordAudio": "Gravar Áudio", "interviewType": "Tipo de Entrevista", "interviewLanguage": "Idioma da Entrevista", "maxDuration": "Duração Máxima da Entrevista" },
    "actions": { "create": "Criar Projeto" },
    "errors": { "createFailed": "Falha ao criar projeto" }
  },
  ja: {
    "title": "新規プロジェクトを作成",
    "fields": { "name": "プロジェクト名", "outline": "インタビューアウトライン", "recordAudio": "音声録音", "interviewType": "インタビュータイプ", "interviewLanguage": "インタビュー言語", "maxDuration": "最大インタビュー時間" },
    "actions": { "create": "プロジェクトを作成" },
    "errors": { "createFailed": "プロジェクトの作成に失敗しました" }
  },
  ar: {
    "title": "إنشاء مشروع جديد",
    "fields": { "name": "اسم المشروع", "outline": "مخطط المقابلة", "recordAudio": "تسجيل الصوت", "interviewType": "نوع المقابلة", "interviewLanguage": "لغة المقابلة", "maxDuration": "الحد الأقصى لمدة المقابلة" },
    "actions": { "create": "إنشاء المشروع" },
    "errors": { "createFailed": "فشل إنشاء المشروع" }
  }
};
